import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#register_trainee",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Certification Summary")
  ])
], -1)
const _hoisted_3 = {
  id: "register_trainee",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top 5" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-4" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Tranche", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "col-md-3 mt-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h4", { class: "mt-4" }, "Certified Trainees", -1)
const _hoisted_14 = { class: "card p-3 position-relative" }
const _hoisted_15 = { class: "row m-0" }
const _hoisted_16 = { class: "col bg-light-success d-flex align-items-center px-6 py-8 rounded-2 me-4" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3x svg-icon-success d-block my-2 col-md-3 mr-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-book fs-3x text-success" })
], -1)
const _hoisted_19 = { class: "col mt-5" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", { class: "text-success fw-bold fs-6 mt-2" }, " Course(s) Certified ", -1)
const _hoisted_21 = { class: "col bg-light-danger d-flex align-items-center px-6 py-8 rounded-2 me-4" }
const _hoisted_22 = { class: "row" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "d-block my-2 col-md-3 mr-4" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chalkboard-teacher fs-3x text-danger" })
], -1)
const _hoisted_24 = { class: "col mt-5" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("p", { class: "text-danger fw-bold fs-6 mt-2" }, " Batch(es) Certified ", -1)
const _hoisted_26 = { class: "col bg-light-success d-flex align-items-center px-6 py-8 rounded-2 me-4" }
const _hoisted_27 = { class: "row" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3x svg-icon-success d-block my-2 col-md-3 mr-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user-tie fs-3x text-success" })
], -1)
const _hoisted_29 = { class: "col mt-5" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("p", { class: "text-success fw-bold fs-6 mt-2" }, " Trainee(s) Certified ", -1)
const _hoisted_31 = { class: "col bg-light-info px-6 py-8 rounded-2" }
const _hoisted_32 = { class: "row" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3x svg-icon-info d-block my-2 col-md-3 mr-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-clock fs-3x text-info" })
], -1)
const _hoisted_34 = { class: "col mt-5" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("p", { class: "text-info fw-bold fs-7 mt-2" }, " Certification Dues (> 30) ", -1)
const _hoisted_36 = { key: 0 }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("h4", { class: "mt-4" }, "Certification Summary", -1)
const _hoisted_38 = { class: "card mb-5 mb-xl-10" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-light px-4",
  role: "button",
  "data-bs-target": "#trainee_data",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "row mt-1 w-100 m-0" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "div pb-2" }, [
        /*#__PURE__*/_createElementVNode("input", {
          type: "text",
          class: "form-control ps-10 w-200px mt-1 form-control-sm",
          style: {"height":"1em"},
          placeholder: "Search"
        })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", {
      class: "col-md-6 mt-1 text-end",
      "data-v-54b12dc8": ""
    }, [
      /*#__PURE__*/_createElementVNode("button", {
        type: "button",
        class: "btn btn-dark fs-7 p-2 rounded-0",
        title: "Download Xlse",
        "data-v-54b12dc8": ""
      }, [
        /*#__PURE__*/_createElementVNode("i", {
          class: "fas fa-file-excel fs-5",
          "data-v-54b12dc8": ""
        }),
        /*#__PURE__*/_createTextVNode(" Excel ")
      ]),
      /*#__PURE__*/_createElementVNode("button", {
        type: "button",
        class: "btn btn-warning fs-7 p-2 rounded-0",
        title: "Download PDF",
        "data-v-54b12dc8": ""
      }, [
        /*#__PURE__*/_createElementVNode("i", {
          class: "fas fa-file-pdf fs-5",
          "data-v-54b12dc8": ""
        }),
        /*#__PURE__*/_createTextVNode(" PDF ")
      ]),
      /*#__PURE__*/_createElementVNode("button", {
        type: "button",
        class: "btn btn-primary fs-7 p-2 rounded-0",
        title: "Download CSV",
        "data-v-54b12dc8": ""
      }, [
        /*#__PURE__*/_createElementVNode("i", {
          class: "fas fa-file-csv fs-5",
          "data-v-54b12dc8": ""
        }),
        /*#__PURE__*/_createTextVNode(" CSV ")
      ])
    ])
  ])
], -1)
const _hoisted_40 = { class: "collapse show" }
const _hoisted_41 = { class: "card-body border-top p-6" }
const _hoisted_42 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_43 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _hoisted_10,
                _createVNode(_component_Multiselect, {
                  modelValue: _ctx.batch.tranche_id,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.batch.tranche_id) = $event)),
                  options: _ctx.optionsTranche,
                  mode: "tags",
                  "clear-on-select": false,
                  placeholder: "Select Tranche",
                  "close-on-select": false,
                  searchable: true,
                  "create-option": true
                }, null, 8, ["modelValue", "options"])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getDash())),
                  type: "button",
                  class: "btn btn-success mt-6 p-3",
                  style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                }, [
                  _createTextVNode(" Search "),
                  _hoisted_12
                ])
              ])
            ]),
            (_ctx.showDashboard)
              ? _withDirectives((_openBlock(), _createElementBlock("div", { key: _ctx.componentKey }, [
                  _hoisted_13,
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          _hoisted_18,
                          _createElementVNode("h4", _hoisted_19, _toDisplayString(_ctx.dashboardData?.course_certified), 1),
                          _hoisted_20
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _hoisted_23,
                          _createElementVNode("h4", _hoisted_24, _toDisplayString(Number(
                            _ctx.dashboardData?.batch_certified
                          ).toLocaleString()), 1),
                          _hoisted_25
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, [
                          _hoisted_28,
                          _createElementVNode("h4", _hoisted_29, _toDisplayString(Number(
                            _ctx.dashboardData?.trainee_certified
                          ).toLocaleString()), 1),
                          _hoisted_30
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, [
                          _hoisted_33,
                          _createElementVNode("h4", _hoisted_34, _toDisplayString(_ctx.dashboardData?.certification_dues), 1),
                          _hoisted_35
                        ])
                      ])
                    ])
                  ]),
                  (_ctx.showDashboard)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                        _hoisted_37,
                        _createElementVNode("div", _hoisted_38, [
                          _hoisted_39,
                          (_openBlock(), _createElementBlock("div", {
                            id: "trainee_data",
                            class: "collapse show",
                            key: _ctx.componentKey
                          }, [
                            _createElementVNode("div", _hoisted_40, [
                              _createElementVNode("div", _hoisted_41, [
                                _createElementVNode("div", _hoisted_42, [
                                  _createVNode(_component_Datatable, {
                                    "table-data": _ctx.list,
                                    "table-header": _ctx.tableHeader,
                                    "enable-items-per-page-dropdown": true
                                  }, {
                                    "cell-sl": _withCtx(({ row }) => [
                                      _createTextVNode(_toDisplayString(row.id), 1)
                                    ]),
                                    "cell-logo": _withCtx(({ row: industry }) => [
                                      (industry?.attach_file_info?.file_path)
                                        ? (_openBlock(), _createElementBlock("img", {
                                            key: 0,
                                            style: {"width":"80px","height":"80px"},
                                            src: 
                                  _ctx.api_url +
                                  industry?.attach_file_info?.file_path
                                ,
                                            alt: ""
                                          }, null, 8, _hoisted_43))
                                        : _createCommentVNode("", true)
                                    ]),
                                    "cell-training_partner": _withCtx(({ row: industry }) => [
                                      _createTextVNode(_toDisplayString(industry?.entity_name), 1)
                                    ]),
                                    "cell-course": _withCtx(({ row: industry }) => [
                                      _createTextVNode(_toDisplayString(industry?.course_count), 1)
                                    ]),
                                    "cell-batch": _withCtx(({ row: industry }) => [
                                      _createTextVNode(_toDisplayString(Number(industry?.batch_count).toLocaleString()), 1)
                                    ]),
                                    "cell-trainee_enrolled": _withCtx(({ row: industry }) => [
                                      _createTextVNode(_toDisplayString(Number(
                                  industry?.enrolled_trainee_count
                                ).toLocaleString()), 1)
                                    ]),
                                    "cell-trainee_certified": _withCtx(({ row: industry }) => [
                                      _createTextVNode(_toDisplayString(Number(industry?.trainee_count).toLocaleString()), 1)
                                    ]),
                                    "cell-female_certified": _withCtx(({ row: industry }) => [
                                      _createTextVNode(_toDisplayString(Number(
                                  industry?.female_trainee_count
                                ).toLocaleString()), 1)
                                    ]),
                                    "cell-dues": _withCtx(({ row: industry }) => [
                                      _createTextVNode(_toDisplayString(industry?.dueOverTrainee), 1)
                                    ]),
                                    _: 1
                                  }, 8, ["table-data", "table-header"])
                                ])
                              ])
                            ])
                          ]))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])), [
                  [_directive_loading, _ctx.load]
                ])
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ])), [
    [_directive_loading, _ctx.loading]
  ])
}